<template>
  <div>
    <div class="mine-box-title">修改用户名</div>
    <div class="mini-form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" prop="name"
                          :rules="[
      { required: true, message: '请输入姓名', trigger: 'blur' },
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--    <van-cell-group>-->
    <!--      <van-field v-model="formData.name" label="用户名" placeholder="请输入姓名" input-align="right"-->
    <!--                 :error="formValidate&&!formData.name"-->
    <!--      />-->
    <!--      <div class="btn">-->
    <!--        <van-button type="danger" round size="large" @click="formSave" v-if="!loading">确定</van-button>-->
    <!--        <van-button type="danger" round size="large" v-else>确定中...</van-button>-->
    <!--      </div>-->
    <!--    </van-cell-group>-->
  </div>

</template>
<style scoped>
.btn {
  padding: 0 0.3rem;
  margin-top: 0.3rem
}

.van-field__control--right {
  color: #323232;
}

</style>
<script>
import {Toast} from 'vant';

export default {
  name: 'Username',
  comments: {
    Toast
  },

  data: function () {
    return {
      formData: {
        name: '',
      },
      loading: false,
      formValidate: false,
      saveLoading: false,
    }
  },
  filter: {},
  mounted() {
    document.title = '修改用户名'
    this.fetch()
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/user/getName', {}, (res) => {
        that.formData.name = res.data
      })
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      // console.log(that.formData, that.$refs[formName])
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // if (that.formData.heying.length == 0) {
          //   this.$message.warning('请上传队伍照片');
          //   return
          // }
          that.saveLoading = true;
          that.$api.get('/api/user/editName', that.formData, (res) => {
            that.$message.success("修改成功")
            that.$router.go(-1)
            that.saveLoading = false;
          }, (res) => {
            if (res.code == 401 || res.code == 402) {
              that.loginShow = true
            } else {
              Toast(res.msg)
            }
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  }
}
</script>



// WEBPACK FOOTER //
// Username.vue?27da6b70